module.exports = __webpack_public_path__ + "img/thumbnail_EasternBrownSnake_u_albino.4e7b972c.png";